import { Box } from '@chakra-ui/react'
import { SearchBox } from '@!/Store/Common/components/Search'
import { buildUrlString } from '@!/Util'

export const SearchForm = ({ keyword, tabName, placeholder = 'マンガを検索' }) => {
  const handleSearch = (searchTerm) => {
    const params = { type: 'keyword', search_term: searchTerm }

    if (tabName) {
      params.tab_name = tabName
    }

    const url = buildUrlString('/store/search', params)

    if (url) {
      window.location.href = url
    }
  }

  return (
    <Box mx={4} my={3}>
      <SearchBox defaultValue={keyword} handleSearch={handleSearch} placeholder={placeholder} />
    </Box>
  )
}
